export const SEARCH_TYPE = {
    FILTER_BY: "filter_by",
    SEARCH_BY: "search_by",
    GROUP_BY: "group_by"
}